import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Apps from './pages/Apps';
import Projects from './pages/Projects';
import Statistics from './pages/Statistics';
import Team from './pages/Team';
import Reports from './pages/Reports';
import Websites from './pages/Websites';
import Designs from './pages/Designs';
import Ideas from './pages/Ideas';
import Pricing from './pages/Pricing';
import BlogManagement from './pages/BlogManagement';
import Orders from './pages/Orders';
import SiteSettings from './pages/SiteSettings';
import WebAntPayments from './pages/WebAntPayments';
import SystemsManagement from './pages/SystemsManagement';
import WaitlistManagement from './pages/WaitlistManagement';
import Layout from './components/Layout';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={
              <ProtectedRoute>
                <Layout>
                  <Navigate to="/dashboard" replace />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/apps" element={
              <ProtectedRoute>
                <Layout>
                  <Apps />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/projects" element={
              <ProtectedRoute>
                <Layout>
                  <Projects />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/analytics" element={
              <ProtectedRoute>
                <Layout>
                  <Statistics />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/team" element={
              <ProtectedRoute>
                <Layout>
                  <Team />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/reports" element={
              <ProtectedRoute>
                <Layout>
                  <Reports />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/websites" element={
              <ProtectedRoute>
                <Layout>
                  <Websites />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/designs" element={
              <ProtectedRoute>
                <Layout>
                  <Designs />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/ideas" element={
              <ProtectedRoute>
                <Layout>
                  <Ideas />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/pricing" element={
              <ProtectedRoute>
                <Layout>
                  <Pricing />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/blog" element={
              <ProtectedRoute>
                <Layout>
                  <BlogManagement />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/orders" element={
              <ProtectedRoute>
                <Layout>
                  <Orders />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/site-settings" element={
              <ProtectedRoute>
                <Layout>
                  <SiteSettings />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/webant-payments" element={
              <ProtectedRoute>
                <Layout>
                  <WebAntPayments />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/systems-management" element={
              <ProtectedRoute>
                <Layout>
                  <SystemsManagement />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/waitlist" element={
              <ProtectedRoute>
                <Layout>
                  <WaitlistManagement />
                </Layout>
              </ProtectedRoute>
            } />

          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
